import React, {memo, useEffect, useState} from 'react';
import {ReactComponent as OnlineClassIcon} from '../../assets/login/online-class.svg';
import {useInputWithFocus} from "../../common/hook/useInputWithFocus";
import {useFormik} from 'formik';
import {Link, useLocation, useNavigate} from "react-router-dom";
import {PASSWORD_CHANGE_TEXT, SEND_BUTTON_TEXT} from "../../entities/constants/constants";
import {useAppDispatch, useAppSelector} from "../../common/hook";
import {resetPassword} from "../../features/model/service/reset-password/reset-password-state";
import {resetPasswordActions} from "../../features/model/slice/resetPasswordSlise";
import {getResetPasswordState} from "../../features/model/selector/get-reset-password-state/getResetPasswordState";
import {
    restorePasswordByEmail
} from "../../features/model/service/restore-password-email-state/restore-password-email-state";
import {resetState} from "../../features/model/slice/resetPasswordEmailSlice";
import {message} from "antd";


export const PasswordChangeForm = memo(() => {
    const {isFilled, handleFocus, handleBlur} = useInputWithFocus([false, false]);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    const dispatch = useAppDispatch();
    const {password, retypePassword} = useAppSelector(getResetPasswordState);
    const [serverMessage, setServerMessage] = useState("");
    const [confirmationStatus, setConfirmationStatus] = useState('loading');
    const errors = useAppSelector((state) => state.resetPassword.errors);
    const messagesError = useAppSelector((state) => state.resetPassword.error);
    const messages = useAppSelector((state) => state.resetPassword.message);
    const registrationStatus = useAppSelector((state) => state.resetPassword.status);
    const success = useAppSelector((state) => state.resetPassword.success);
    const navigate = useNavigate();

    const [messageApi, contextHolder] = message.useMessage();







    const showSuccess = (content: string) => {
        messageApi.open({
            type: 'success',
            content,
        });
    };

    const showError = (content: string) => {
        messageApi.open({
            type: 'error',
            content,
        });
    };



    useEffect(() => {


        if (registrationStatus === 'fulfilled') {
            setConfirmationStatus('success');

            showSuccess(messages);
            setTimeout(() => {
                navigate('/');
            }, 1000);
        } else if (registrationStatus === 'rejected') {
            showError(messagesError);
        }
    }, [registrationStatus, navigate, messages,success]);


    const formik = useFormik({
        initialValues: {
            password,
            retypePassword,
            token,
        },
        onSubmit: async (values) => {
            dispatch(resetPasswordActions.setToken(token));
            dispatch(resetPasswordActions.setPassword(values.password));
            dispatch(resetPasswordActions.setRetypePassword(values.retypePassword));
            const result = await dispatch(resetPassword(values));


            if (restorePasswordByEmail.fulfilled.match(result)) {
                formik.resetForm();
                // @ts-ignore
                dispatch(resetState());
                setServerMessage(result.payload.message);
            }
        },
    });





    return (
        <div className="app service-page">
            {contextHolder}
            <div className="bg-box"><OnlineClassIcon/></div>
            <div className="form-box">
                <div className="sub-box">
                    <p className="h3 popup-title">{PASSWORD_CHANGE_TEXT}</p>
                    <form
                        className="form"
                        onSubmit={formik.handleSubmit}
                    >
                        <div
                            className={`field required ${isFilled[0] ? 'filled' : ''} ${errors.password ? 'error-field' : ''}`}>
                            <label
                                className={`field-name ${formik.values.password ? 'active-label' : ''}`}>Password</label>
                            <div className="inp-box">
                                <input
                                    type="password"
                                    name="password"
                                    className="form-control"
                                    onFocus={() => handleFocus(0)}
                                    onChange={formik.handleChange}
                                    value={formik.values.password}
                                    onBlur={handleBlur}
                                />
                            </div>
                            {errors.password && <p className="field-error">{errors.password}</p>}
                        </div>
                        <div className={`field required ${isFilled[1] ? 'filled' : ''} ${errors.retypePassword ? 'error-field' : ''}`}>
                            <label
                                className={`field-name ${formik.values.retypePassword ? 'active-label' : ''}`}>
                                Repeat password</label>
                            <div className="inp-box">
                                <input
                                    type="password"
                                    name="retypePassword"
                                    className="form-control"
                                    onFocus={() => handleFocus(1)}
                                    onChange={formik.handleChange}
                                    value={formik.values.retypePassword}
                                    onBlur={handleBlur}
                                />
                            </div>
                            {errors.retypePassword && <p className="field-error">{errors.retypePassword}</p>}
                        </div>
                        <button type="submit" className="btn full-width"><span>{SEND_BUTTON_TEXT}</span>
                        </button>
                        <div className="form-prompt">
                            <p>Вернуться ко <Link to="/">входу</Link></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
});

